import { FC, ReactElement } from "react";
import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { responsiveFontSizes, spacing, pxToRem } from "@/utils/responsive";

interface IMetric {
  title: string;
  value: string | number;
  icon: string;
}

interface IAceRange {
  minDate: string;
  maxDate: string;
}

interface IMetricsCardProps {
  data: IMetric[];
  aceRange?: IAceRange;
}

const MerticsCard: FC<IMetricsCardProps> = ({ data, aceRange }): ReactElement => {
  return (
    <Card sx={{ p: { xs: 1, md: 1.25 }, height: "100%" }}>
      <Stack height="100%" justifyContent="space-between">
        <Stack mb={spacing.lg}>
          <Typography 
            color="#030712" 
            fontWeight={500}
            sx={{
              fontSize: responsiveFontSizes['lg'],
            }}
          >
            Import Metrics
          </Typography>
          {aceRange && aceRange.minDate && aceRange.maxDate && (
            <Typography 
              color="#6B7280" 
              fontWeight={400} 
              mt={0.5}
              sx={{
                fontSize: responsiveFontSizes.xs,
              }}
            >
              ACE Date Range: {format(new Date(aceRange.minDate), "MMM dd, yyyy")} - {format(new Date(aceRange.maxDate), "MMM dd, yyyy")}
            </Typography>
          )}
        </Stack>
        <Grid container spacing={{ xs: 0.75, md: 1 }} sx={{ flex: 1 }}>
          {data.map(({ title, value, icon }, index) => {
            return (
              <Grid item xs={6} key={index + 1}>
                <Stack
                  width="100%"
                  height="100%"
                  borderRadius={pxToRem(6)}
                  p={{ xs: 0.75, md: 1 }}
                  sx={{
                    backgroundColor: "#0B494B1A",
                    minHeight: { xs: pxToRem(60), md: pxToRem(80) },
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: { xs: 14, md: 16 },
                      height: { xs: 14, md: 16 },
                      mb: { xs: spacing.xs, md: spacing.xs },
                    }}
                    src={icon}
                    alt="metric icon"
                  />
                  <Typography
                    variant="caption"
                    fontFamily="Manrope"
                    fontWeight={600}
                    color="neutral.500"
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="h3"
                    fontWeight={700}
                    color="#2E2C34"
                    fontFamily="Plus Jakarta Sans"
                    sx={{
                      fontSize: responsiveFontSizes.lg,
                    }}
                  >
                    {value}
                  </Typography>
                </Stack>
              </Grid>
            );
          })}
        </Grid>
        {/* <Button variant="white-outlined" fullWidth size="large">
          <Typography color="#052223" variant="body1" fontWeight={500}>
            View Details
          </Typography>
        </Button> */}
      </Stack>
    </Card>
  );
};

export default MerticsCard;
